var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logologin"},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{staticClass:"homeLogo",attrs:{"src":_vm.logo,"max-width":"180","max-height":"76"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }